<template>
  <!-- <div class="forget-warpper">
    <div class="container-img">
      <div class="forget-img">
        <h1 class="websiteTitle" v-text="websiteTitle"></h1>
      </div>
      <div class="container">
        <infoForm ref="infoForm" title="忘记密码" fromType="forget" @on-submit="submitHandle" submit="提交" align="返回登录" @on-align="onAlign">
          <el-form-item slot="forget" prop="captcha">
            <el-input v-model="captcha" placeholder="短信验证" type="username">
              <el-button slot="append" type="primary" class="sendBtn" @click="sendPhoneCode" :disabled="sendCodeBtnDisable">{{ code_tip }}</el-button>
            </el-input>
          </el-form-item>
        </infoForm>
      </div>
    </div>
    <div class="record_num" v-text="icp_number"></div>
  </div> -->
  <Main>
    <infoForm ref="infoForm" title="忘记密码" fromType="forget" @on-submit="submitHandle" submit="提交" align="返回登录" @on-align="onAlign">
      <el-form-item slot="forget" prop="captcha">
        <!-- <input v-model="captcha" placeholder="短信验证" type="username">
        <el-button slot="append" type="primary" class="sendBtn" @click="sendPhoneCode" :disabled="sendCodeBtnDisable">{{ code_tip }}</el-button> -->
        <div class="forget-container">
          <input class="forget-input" v-model="captcha" type="text" placeholder="短信验证">
          <el-button class="get-captcha" size="mini"  @click="sendPhoneCode" :disabled="sendCodeBtnDisable">{{ code_tip }}</el-button>
        </div>
      </el-form-item>
    </infoForm>
  </Main>
</template>

<script>
import util from "@/utils";
import infoForm from "@/components/infoForm/index.vue";
import Main from "@/components/main/main.vue";
export default {
  name: "",
  components: {
    infoForm,
    Main
  },
  props: {},
  data () {
    return {
      code_time: 60,
      code_tip: "发送验证码",
      sendCodeBtnDisable: false,
      captcha: "",
      icp_number: process.env.VUE_APP_ICP_NUMBER,
      websiteTitle: process.env.VUE_APP_WEBSITE_TITLE,
    };
  },
  methods: {
    onAlign (type) {
      this.go("/login");
    },
    go (url) {
      this.$router.push({
        path: url,
      });
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /**
     * 提交
     */
    async submitHandle (userInfo) {
      try {
        var params = {
          mobile: userInfo.username,
          password: userInfo.password,
          captcha: this.captcha,
        };
        let res = await forgetPassword(params);
        if (res.success) {
          this.elementTips("success", res.message);
          setTimeout(() => {
            this.go("/login");
          }, 1500);
        } else {
          this.elementTips("error", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 发送验证码
      注册绑定模式:0, 登录验证:1, 修改密码模式:2, 修改手机号:3；
     * */
    async sendPhoneCode () {
      try {
        let mobile = this.$refs.infoForm.loginForm.username;
        if (mobile === "") {
          this.elementTips("error", "手机号码不能为空");
          return;
        }
        const params = {
          smsMode: "2",
          mobile: mobile,
        };
        debugger
        console.log('params',params);
        let res = await getCaptcha(params);
        if (res.success) {
          this.countDown();
          this.elementTips("success", res.message);
          this.sendCodeBtnDisable = true;
        } else {
          this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
          this.elementTips("warning", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 倒计时
     * */
    countDown () {
      const timer = setInterval(() => {
        this.code_tip = this.code_time + "s";
        this.code_time--;
        if (this.code_time <= 0) {
          clearInterval(timer);
          this.sendCodeBtnDisable = false;
          this.code_tip = "获取验证码";
          this.code_time = 60;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.forget-container {
  position: relative;
  .forget-input {
    width: 100%;
    height: 30px;
    border-style: none none none;
    border-bottom: 1px solid #dcdcdc;
    width: calc(100% - 60px);
    background-image: url("../../assets/images/login-code.png");
    background-size: 15px 15px;
    background-position: 3px 8px;
    background-repeat: no-repeat;
    padding: 0 0 0 50px;
  }
  .forget-input:focus {
    outline: none;
    border-bottom: 1px solid #dcdcdc;
  }
}
 .get-captcha {
  position: absolute;
  top: 9px;
  right: 0;
  background-color: #fff;
  color: #fc701a;
  border: none; // 去掉边框
  outline: none; // 去掉点击按钮后的边框
  cursor: pointer;
}

input::-webkit-input-placeholder {
  color: #c0c0c0;
  font-size: 14px;
}
</style>
